import { useField } from "vee-validate";
import { reactive } from "vue";

/**
 * Adapts a VeeValidate field to the IModal interface expected by TextInput/PasswordInput.
 * Must be called inside <script setup> within a useForm context.
 */
export function useVeeField<T = string>(name: string) {
  const { value, errorMessage } = useField<T>(name);

  return reactive({
    get $model() {
      return value.value;
    },
    set $model(v: T) {
      value.value = v;
    },
    get $error() {
      return !!errorMessage.value;
    },
    get $errors() {
      return errorMessage.value ? [{ $message: errorMessage.value }] : [];
    },
  });
}
